// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"315e2ef0","453":"4acdad54","553":"22654df7","977":"79f92eec"}[chunkId] + ".chunk.js";
};